import React from 'react';
import {
  CompassOutlined,
  DashboardOutlined,
  FormOutlined,
  HomeOutlined,
  LayoutOutlined,
  LineChartOutlined,
  TableOutlined,
  UserOutlined,
  BlockOutlined,
} from '@ant-design/icons';
import { ReactComponent as NftIcon } from '@app/assets/icons/nft-icon.svg';
import { readUser } from '@app/services/localStorage.service';

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  isExternal?: boolean;
  roles?: string[]
}
const user = readUser();
export const sidebarNavigation: SidebarNavigationItem[] = [
  // {
  //   title: 'common.nft-dashboard',
  //   key: 'company-dashboard',
  //   // TODO use path variable
  //   url: '/company',
  //   icon: <NftIcon />,
  //   isExternal: true,
  //   roles:[5]
  // },
  {
    title: 'common.nft-dashboard',
    key: 'nft-dashboard',
    // TODO use path variable
    url: '/admin',
    // icon: <NftIcon />,
    roles: ['Admin', 'Analyst']
  },
  {
    title: 'deliveries.title',
    key: 'title-deliveries',
    // icon: <HomeOutlined />,
    roles: ['Admin', 'Analyst'],
    children: [
      {
        title: 'deliveries.view',
        key: 'view.deliveries',
        url: '/admin/deliveries/list',
      }
    ],
  },
  {
    title: 'users.title',
    key: 'sidebar',
    roles: ['Admin'],
    // icon: <HomeOutlined />,
    children: [
      {
        title: 'users.view',
        key: 'users-list',
        url: '/admin/users/list',
      },
      {
        title: 'users.add',
        key: 'users-add',
        url: '/admin/users/add',
      },
    ],
  },
  {
    title: 'ManageAreas.title',
    key: 'manage-area',
    url:'/admin/manage-areas/view',
    roles: ['Admin','Analyst']
  },
  
  // {
  //   title: 'employee_external.sidebar',
  //   key: 'employees_main',
  //   icon: <HomeOutlined />,
  //   isExternal: true,
  //   roles: [4], // add 5 later
  //   children: [
  //     {
  //       title: 'employee_external.list',
  //       key: 'employees/list',
  //       url: '/company/employees/list',
  //     },
  //     {
  //       title: 'employee_external.add',
  //       key: 'employees-add',
  //       url: '/company/employees/add',
  //     },
  //   ],
  // },
  {
    title: 'variants.title',
    key: 'variants.title',
    // icon: <HomeOutlined />,
    roles: ['Admin', 'Analyst'],
    children: [
      {
        title: 'variants.view',
        key: 'view.variants',
        url: '/admin/variants/list',
      },
      {
        title: 'variants.add',
        key: 'add.variants',
        url: '/admin/variants/add',
      },
    ],
  },

  {
    title: 'categories.title',
    key: 'categories.title',
    // icon: <HomeOutlined />,
    roles: ['Admin', 'Analyst'],
    children: [
      {
        title: 'categories.view',
        key: 'view.categories',
        url: '/admin/categories/list',
      },
      {
        title: 'categories.add',
        key: 'add.categories',
        url: '/admin/categories/add',
      },
    ],
  },
  {
    title: 'Push Notifications',
    key: 'push-notifications.title',
    // icon: <HomeOutlined />,
    roles: ['Admin', 'Analyst'],
    children: [
      {
        title: 'View Push Notifications',
        key: 'view.push-notifications',
        url: '/admin/push-notifications/list',
      },
      {
        title: 'Add Push Notification',
        key: 'add.push-notifications',
        url: '/admin/push-notifications/add',
      },
    ],
  },
  {
    title: 'products.title',
    key: 'products.title',
    roles: ['Admin', 'Analyst'],
    // icon: <HomeOutlined />,
    children: [
      {
        title: 'products.view',
        key: 'view.products',
        url: '/admin/products/list',
      },
      {
        title: 'products.add',
        key: 'add.products',
        url: '/admin/products/add',
      },
    ],
  },
  {
    title: 'orders.title',
    key: 'title-orders',
    roles: ['Admin', 'Analyst'],
    // icon: <HomeOutlined />,
    children: [
      {
        title: 'orders.view',
        key: 'view.orders',
        url: '/admin/orders/list',
      }
    ],
  },
  {
    title: 'invoices.title',
    key: 'title-invoices',
    roles: ['Admin'],
    // icon: <HomeOutlined />,
    children: [
      {
        title: 'invoices.view',
        key: 'view.invoices',
        url: '/admin/invoices/list',
      }
    ],
  },
  {
    title: 'subscriptions.title',
    key: 'title-subscriptions',
    roles: ['Admin', 'Analyst'],
    // icon: <HomeOutlined />,
    children: [
      {
        title: 'subscriptions.view',
        key: 'view.subscriptions',
        url: '/admin/subscriptions/list',
      }
    ],
  },

  {
    title: 'riders.title',
    key: 'title-riders',
    roles: ['Admin', 'Analyst'],
    // icon: <HomeOutlined />,
    children: [
      {
        title: 'riders.view',
        key: 'view.riders',
        url: '/admin/riders/list',
      }
    ],
  },
  {
    title: 'transactions.title',
    key: 'title-transactions',
    roles: ['Admin'],
    // icon: <HomeOutlined />,
    children: [
      {
        title: 'transactions.view',
        key: 'view.transactions',
        url: '/admin/transactions/list',
      }
    ],
  },

  {
    title: 'Payment Logs',
    key: 'title-payment-logs',
    roles: ['Admin'],
    children: [
      {
        title: 'View Payment Logs',
        key: 'view.payment-logs',
        url: '/admin/payment-logs/list',
      }
    ],
  },

  {
    title: 'Delivery Slots',
    key: 'title-delivery-slots',
    roles: ['Admin'],
    children: [
      {
        title: 'Manage Slots',
        key: 'view.delivery-slots',
        url: '/admin/delivery-slots/list',
      }
    ],
  },

  {
    title: 'clients.title',
    key: 'title-clients',
    roles: ['Admin','Analyst'],
    // icon: <HomeOutlined />,
    children: [
      {
        title: 'clients.view',
        key: 'view.clients',
        url: '/admin/clients/list',
      }
    ],
  },

  {
    title: 'recharge.title',
    key: 'title-recharge',
    roles: ['Admin'],
    url: '/admin/recharge/manage'
    // icon: <HomeOutlined />,
   
  },
  {
    title: 'First Recharge Coupons',
    key: 'title-coupons',
    roles: ['Admin'],
    url: '/admin/coupons/manage',
  },
  {
    title: 'refund.title',
    key: 'title-refund',
    roles: ['Admin'],
    url: '/admin/refund/manage'
    // icon: <HomeOutlined />,
   
  },

  {
    title: 'Miscellaneous Settings',
    key: 'misc-settings',
    url: '/admin/misc-settings',
    roles: ['Admin'],
  },
  {
    title: 'Meta Ads Configuration',
    key: 'meta-ads-settings',
    url: '/admin/meta-ads/settings',
    roles: ['Admin'],
  },
  {
    title: 'Home Sliders / Banners',
    key: 'home-sliders-banners',
    url: '/admin/sliders',
    roles: ['Admin'],
  },


  // {
  //   title: 'common.medical-dashboard',
  //   key: 'medical-dashboard',
  //   url: '/medical-dashboard',
  //   icon: <DashboardOutlined />,
  // },
  // {
  //   title: 'common.apps',
  //   key: 'apps',
  //   icon: <HomeOutlined />,
  //   children: [
  //     {
  //       title: 'common.feed',
  //       key: 'feed',
  //       url: '/apps/feed',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.authPages',
  //   key: 'auth',
  //   icon: <UserOutlined />,
  //   children: [
  //     {
  //       title: 'common.login',
  //       key: 'login',
  //       url: '/auth/login',
  //     },
  //     {
  //       title: 'common.signUp',
  //       key: 'singUp',
  //       url: '/auth/sign-up',
  //     },
  //     {
  //       title: 'common.lock',
  //       key: 'lock',
  //       url: '/auth/lock',
  //     },
  //     {
  //       title: 'common.forgotPass',
  //       key: 'forgotPass',
  //       url: '/auth/forgot-password',
  //     },
  //     {
  //       title: 'common.securityCode',
  //       key: 'securityCode',
  //       url: '/auth/security-code',
  //     },
  //     {
  //       title: 'common.newPassword',
  //       key: 'newPass',
  //       url: '/auth/new-password',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.forms',
  //   key: 'forms',
  //   icon: <FormOutlined />,
  //   children: [
  //     {
  //       title: 'common.advancedForms',
  //       key: 'advanced-forms',
  //       url: '/forms/advanced-forms',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.dataTables',
  //   key: 'dataTables',
  //   url: '/data-tables',
  //   icon: <TableOutlined />,
  // },
  // {
  //   title: 'common.charts',
  //   key: 'charts',
  //   url: '/charts',
  //   icon: <LineChartOutlined />,
  // },
  // {
  //   title: 'common.maps',
  //   key: 'maps',
  //   icon: <CompassOutlined />,
  //   children: [
  //     {
  //       title: 'common.googleMap',
  //       key: 'google-maps',
  //       url: '/maps/google-maps',
  //     },
  //     {
  //       title: 'common.leafletMap',
  //       key: 'leaflet-maps',
  //       url: '/maps/leaflet-maps',
  //     },
  //     {
  //       title: 'common.reactSimpleMaps',
  //       key: 'react-simple-maps',
  //       url: '/maps/react-simple-maps',
  //     },
  //     {
  //       title: 'common.pigeonMaps',
  //       key: 'pigeon-maps',
  //       url: '/maps/pigeon-maps',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.pages',
  //   key: 'pages',
  //   icon: <LayoutOutlined />,
  //   children: [
  //     {
  //       title: 'common.profilePage',
  //       key: 'profile',
  //       url: '/profile',
  //     },
  //     {
  //       title: 'common.serverError',
  //       key: 'serverError',
  //       url: '/server-error',
  //     },
  //     {
  //       title: 'common.clientError',
  //       key: '404Error',
  //       url: '/404',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.ui',
  //   key: 'ui',
  //   icon: <BlockOutlined />,
  //   children: [
  //     {
  //       title: 'common.alert',
  //       key: 'alert',
  //       url: '/ui-components/alert',
  //     },
  //     {
  //       title: 'common.avatar',
  //       key: 'avatar',
  //       url: '/ui-components/avatar',
  //     },
  //     {
  //       title: 'common.autocomplete',
  //       key: 'auto-complete',
  //       url: '/ui-components/auto-complete',
  //     },
  //     {
  //       title: 'common.badge',
  //       key: 'badge',
  //       url: '/ui-components/badge',
  //     },
  //     {
  //       title: 'common.breadcrumbs',
  //       key: 'breadcrumbs',
  //       url: '/ui-components/breadcrumbs',
  //     },
  //     {
  //       title: 'common.button',
  //       key: 'button',
  //       url: '/ui-components/button',
  //     },
  //     {
  //       title: 'common.checkbox',
  //       key: 'checkbox',
  //       url: '/ui-components/checkbox',
  //     },
  //     {
  //       title: 'common.collapse',
  //       key: 'collapse',
  //       url: '/ui-components/collapse',
  //     },
  //     {
  //       title: 'common.dateTimePicker',
  //       key: 'dateTimePicker',
  //       url: '/ui-components/date-time-picker',
  //     },
  //     {
  //       title: 'common.dropdown',
  //       key: 'dropdown',
  //       url: '/ui-components/dropdown',
  //     },
  //     {
  //       title: 'common.input',
  //       key: 'input',
  //       url: '/ui-components/input',
  //     },
  //     {
  //       title: 'common.modal',
  //       key: 'modal',
  //       url: '/ui-components/modal',
  //     },
  //     {
  //       title: 'common.notification',
  //       key: 'notification',
  //       url: '/ui-components/notification',
  //     },
  //     {
  //       title: 'common.pagination',
  //       key: 'pagination',
  //       url: '/ui-components/pagination',
  //     },
  //     {
  //       title: 'common.popconfirm',
  //       key: 'popconfirm',
  //       url: '/ui-components/popconfirm',
  //     },
  //     {
  //       title: 'common.popover',
  //       key: 'popover',
  //       url: '/ui-components/popover',
  //     },
  //     {
  //       title: 'common.progress',
  //       key: 'progress',
  //       url: '/ui-components/progress',
  //     },
  //     {
  //       title: 'common.radio',
  //       key: 'radio',
  //       url: '/ui-components/radio',
  //     },
  //     {
  //       title: 'common.rate',
  //       key: 'rate',
  //       url: '/ui-components/rate',
  //     },
  //     {
  //       title: 'common.result',
  //       key: 'result',
  //       url: '/ui-components/result',
  //     },
  //     {
  //       title: 'common.select',
  //       key: 'select',
  //       url: '/ui-components/select',
  //     },
  //     {
  //       title: 'common.skeleton',
  //       key: 'skeleton',
  //       url: '/ui-components/skeleton',
  //     },
  //     {
  //       title: 'common.spinner',
  //       key: 'spinner',
  //       url: '/ui-components/spinner',
  //     },
  //     {
  //       title: 'common.steps',
  //       key: 'steps',
  //       url: '/ui-components/steps',
  //     },
  //     {
  //       title: 'common.switch',
  //       key: 'switch',
  //       url: '/ui-components/switch',
  //     },
  //     {
  //       title: 'common.tabs',
  //       key: 'tabs',
  //       url: '/ui-components/tabs',
  //     },
  //     {
  //       title: 'common.upload',
  //       key: 'upload',
  //       url: '/ui-components/upload',
  //     },
  //   ],
  // },
];
